import Vue from 'vue'
import Vuex from 'vuex'

/* Theme Core */
import verticalMenu from './vertical-menu'
import appConfig from './app-config'
import app from './app'
/* App Core */
import users from './Admin/Core/users'
import userTypes from './Admin/Core/user_types'
import smtpConfig from './Admin/Core/smtpconfig'
import abilities from './Admin/Core/abilities'
import cropperUploads from './Admin/Core/cropper_uploads'
import fileUpload from './Admin/Core/file_upload'
/* App Data */
import customers from './Admin/App/customers'
import customerAddresses from './Admin/App/customer_addresses'
import customerUsers from './Admin/App/customer_users'
import eventLogs from './Admin/App/event_logs'
import licenses from './Admin/App/licenses'
import params from './Admin/App/params'
import paramSchemes from './Admin/App/param_schemes'
import packageLimitParamsSchemes from './Admin/App/package_limit_params_schemes'
import projectPackageLimits from './Admin/App/project_package_limits'
import projectPackages from './Admin/App/project_packages'
import projects from './Admin/App/projects'
import projectEventLogs from './Admin/App/projects_event_logs'
import sectors from './Admin/Defines/sectors'
import zennoStocks from './Admin/App/zenno_stocks'

/* Admin Defines */
import customerTypes from './Admin/Defines/customer_types'
import cities from './Admin/Defines/cities'
import countries from './Admin/Defines/countries'

/* Apps */
import drUsers from './Apps/dr/dr_users'
import drUserTypes from './Apps/dr/dr_user_types'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    abilities,
    cropperUploads,
    fileUpload,
    smtpConfig,
    users,
    userTypes,
    verticalMenu,
    customers,
    customerAddresses,
    customerUsers,
    customerTypes,
    cities,
    countries,
    eventLogs,
    licenses,
    params,
    paramSchemes,
    packageLimitParamsSchemes,
    projectPackageLimits,
    projectPackages,
    projects,
    projectEventLogs,
    sectors,
    zennoStocks,
    drUsers,
    drUserTypes,
  },
  strict: process.env.DEV,
})
